import axios from "axios";

import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

const getYears = async (an8) => {

  const token = await authHeader();

  return axios.get( `${baseUrl}/date/year/${an8}`,
   { headers: token }
   ).then(
    (response) => {
      return response.data;
    });
};

const getMonth = async (an8, year) => {

  const token = await authHeader();

  return axios.get(`${baseUrl}/date/month/${year}/${an8}` ,
   { headers: token }
   ).then(
    (response) => {
      return response.data;
    });
};

const getCompany = async (an8, year, month) => {

  const token = await authHeader();

  return axios.get(`${baseUrl}/company/${year}/${month}/${an8}`,
   { headers: token }
   ).then(
    (response) => {
      return response.data;
    });
};

const getRetirement = async (an8, year, month,  company) => {

  const token = await authHeader();

  return axios.get(`${baseUrl}/retirement/${year}/${month}/${company}/${an8}`,
   { headers: token }
   ).then(
    (response) => {
      return response.data;
    });
};

const getCement = async (an8, year, month, company, retirement) => {

  const token = await authHeader();

  return axios.get(`${baseUrl}/cement/${year}/${month}/${company}/${retirement}/${an8}`,
   { headers: token }
   ).then(
    (response) => {
      return response.data;
    });
};

const getPreviousProgramByFilters = async (an8, year, month, company, retirement, cement) => {

  const token = await authHeader();

  const url = `${ baseUrl }/calendar/${year}/${month}/${company}/${retirement}/${cement}/${an8}`;

  return axios.get(url,
  { headers: token }
  ).then(
      (response) => {
        return response.data;
      });
};

export default {
    getYears,
    getMonth,
    getCompany,
    getRetirement,
    getCement,
    getPreviousProgramByFilters,
};